import { useCallback, useLayoutEffect, useRef, useState } from 'react';

export const useIsTruncated = <Element extends HTMLElement>(value: string) => {
    const elementRef = useRef<Element | null>(null);
    const resizeObserverRef = useRef<ResizeObserver | null>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    const updateIsTruncated = useCallback((element: Element) => {
        setIsTruncated(element.scrollWidth > element.clientWidth);
    }, []);

    const ref = useCallback(
        (element: Element | null) => {
            resizeObserverRef.current?.disconnect();
            elementRef.current = element;

            if (!element) {
                return;
            }

            updateIsTruncated(element);

            if (typeof ResizeObserver === 'undefined') {
                return;
            }

            resizeObserverRef.current = new ResizeObserver(() => updateIsTruncated(element));
            resizeObserverRef.current.observe(element);
        },
        [updateIsTruncated]
    );

    useLayoutEffect(() => {
        const element = elementRef.current;

        if (element) {
            updateIsTruncated(element);
        }
    }, [updateIsTruncated, value]);

    return { ref, isTruncated };
};
